import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch() {
    // Error sudah di-capture di getDerivedStateFromError; tidak perlu log ke konsol
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: 'var(--in-bg)', padding: 24,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}>
        <div style={{
          maxWidth: 480, width: '100%', background: 'var(--in-card)',
          border: '1px solid var(--in-border)', borderRadius: 12, padding: '40px 36px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 36, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: 'var(--in-text)', marginBottom: 8 }}>
            Terjadi Kesalahan
          </h2>
          <p style={{ fontSize: 13, color: 'var(--in-text-muted)', lineHeight: 1.6, marginBottom: 24 }}>
            Halaman mengalami masalah yang tidak terduga.
            Silakan muat ulang halaman atau kembali ke beranda.
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => window.location.reload()} className="btn btn-primary">
              Muat Ulang
            </button>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/'; }}
              className="btn btn-secondary"
            >
              Ke Beranda
            </button>
          </div>
        </div>
      </div>
    );
  }
}
